import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';

/**
 * In production we serve the app on custom domains that each host the Firebase
 * auth handler (`/__/auth/handler`). Using the current hostname as `authDomain`
 * keeps the OAuth handler same-origin → reliable redirects, no third-party
 * cookie issues. localhost has no handler, so fall back to the configured
 * domain there (and sign-in uses a popup in dev).
 */
function resolveAuthDomain(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host !== 'localhost' && host !== '127.0.0.1') return host;
  }
  return import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: resolveAuthDomain(),
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');
